import Layout from '../views/layout/Layout'
import RouteView from '../views/layout/RouteView'

const approveRoutes = {
  path: '/approve',
  component: Layout,
  redirect: '/approve/workbench/center',
  defaultPath: '/approve/workbench/center',
  name: 'approveRoot',
  meta: { title: '审批中心', icon: 'approve', alwaysShow: true },
  children: [
    {
      path: 'workbench',
      name: 'approvalWorkbench',
      component: RouteView,
      meta: { title: '审批工作台', icon: 'approve' },
      children: [
        {
          path: 'center',
          alias: '/approve/approvalCenter/mySubmitted',
          name: 'mySubmitted',
          morePath: '/approve/workbench/center',
          component: () => import('@/views/approve/commonApprove/ApprovalCenter'),
          meta: { title: '审批中心', icon: 'approval-commit' }
        },
        {
          path: 'detail',
          alias: '/approve/approvalCenter/mySubmittedDetail',
          name: 'mySubmittedDetail',
          component: () => import('@/views/approve/commonApprove/ApprovalDetail'),
          meta: { title: '查看流程详情' },
          hidden: true
        },
        {
          path: 'contractResubmit',
          alias: '/approve/approvalCenter/contractResubmit',
          name: 'contractApprovalResubmit',
          component: () => import('@/views/accounting/contractInfo/resubmit'),
          meta: { title: '合同审批重新提交' },
          hidden: true
        }
      ]
    },
    {
      path: 'configuration',
      name: 'approvalConfiguration',
      component: RouteView,
      meta: { title: '审批配置', icon: 'approval-commit' },
      children: [{
        path: 'flows',
        alias: '/approve/approvalCenter/flowConfig',
        name: 'flowConfig',
        morePath: '/approve/configuration/flows',
        component: () => import('@/views/approve/flowConfig/index'),
        meta: { title: '流程配置', icon: 'approval-commit' }
      }]
    }
  ]
}

export default approveRoutes



// WEBPACK FOOTER //
// ./src/router/approve.js